import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer'
import { Policy } from '../../pages/PolicyDetail'

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 60,
        paddingBottom: 60,
        paddingHorizontal: 60,
        color: '#222',
    },
    headerRow: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: 40,
    },
    compania: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 12,
        textAlign: 'right',
    },
    ciudadFecha: {
        marginBottom: 30,
    },
    referenciaBlock: {
        marginBottom: 24,
    },
    refRow: {
        flexDirection: 'row',
        marginBottom: 5,
    },
    refLabel: {
        fontFamily: 'Helvetica-Bold',
        width: 150,
    },
    refValue: {
        flex: 1,
    },
    cuerpo: {
        lineHeight: 1.7,
        marginBottom: 14,
        textAlign: 'justify',
    },
    despedida: {
        marginTop: 40,
        marginBottom: 10,
        lineHeight: 1.7,
    },
    firmaSection: {
        marginTop: 40,
    },
    firmaLabel: {
        marginBottom: 10,
    },
    firmaNombre: {
        fontFamily: 'Helvetica-Bold',
        marginBottom: 4,
    },
})

function formatFechaCorta(fecha: string | undefined | null): string {
    if (!fecha) return '—'
    try {
        const raw = fecha.replace(/^(\d{4})\d+/, '$1')
        const date = new Date(raw)
        if (isNaN(date.getTime())) return fecha
        return new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'Europe/Madrid',
        }).format(date)
    } catch {
        return fecha
    }
}

type Props = {
    policy: Policy
}

export default function CartaAnulacionPDF({ policy }: Props) {
    const hoy = new Intl.DateTimeFormat('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'Europe/Madrid',
    }).format(new Date())

    const ciudadCliente = 'Córdoba'

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                {/* Compañía arriba a la derecha */}
                <View style={styles.headerRow}>
                    <Text style={styles.compania}>
                        {policy.nombreCompania || '—'}
                    </Text>
                </View>

                {/* Ciudad y fecha abajo a la izquierda */}
                <View style={styles.ciudadFecha}>
                    <Text>Córdoba, a {hoy}</Text>
                </View>

                {/* Referencia de la póliza */}
                <View style={styles.referenciaBlock}>
                    <View style={styles.refRow}>
                        <Text style={styles.refLabel}>Nº de póliza:</Text>
                        <Text style={styles.refValue}>{policy.numero || '—'}</Text>
                    </View>
                    <View style={styles.refRow}>
                        <Text style={styles.refLabel}>Compañía:</Text>
                        <Text style={styles.refValue}>{policy.nombreCompania || '—'}</Text>
                    </View>
                    <View style={styles.refRow}>
                        <Text style={styles.refLabel}>Ramo/Modalidad:</Text>
                        <Text style={styles.refValue}>{policy.descripcionSubramo || '—'}</Text>
                    </View>
                    <View style={styles.refRow}>
                        <Text style={styles.refLabel}>Tomador:</Text>
                        <Text style={styles.refValue}>{policy.nombreCliente || '—'}</Text>
                    </View>
                    <View style={styles.refRow}>
                        <Text style={styles.refLabel}>Riesgo asegurado:</Text>
                        <Text style={styles.refValue}>—</Text>
                    </View>
                    <View style={styles.refRow}>
                        <Text style={styles.refLabel}>Fecha de rescisión:</Text>
                        <Text style={styles.refValue}>{formatFechaCorta(policy.fechaLimiteTemporal)}</Text>
                    </View>
                </View>

                {/* Cuerpo */}
                <Text style={styles.cuerpo}>Estimados Señores:</Text>

                <Text style={styles.cuerpo}>
                    Tengo suscrito con Vds. el contrato de seguro cuyos datos se detallan en la referencia, y por medio de la presente deseo manifestarles mi decisión de no proceder a la prórroga del mismo, circunstancia que pongo en su conocimiento dando así cumplimiento a lo dispuesto en las Condiciones Generales reguladoras del citado contrato de seguro.
                </Text>

                <Text style={styles.cuerpo}>
                    Sin otro particular y a la espera de que dispongan lo oportuno para atender la presente solicitud, aprovecho la ocasión para saludarles atentamente.
                </Text>

                {/* Firma */}
                <View style={styles.firmaSection}>
                    <Text style={styles.firmaLabel}>El tomador del seguro,</Text>
                    <Text style={styles.firmaNombre}>{policy.nombreCliente || '___________________________'}</Text>
                    <Text>{policy.nifCliente || '___________________________'}</Text>
                </View>

            </Page>
        </Document>
    )
}
